import React, { useState } from "react";
import { DatePicker, Table, Typography } from "antd";
import { toaster } from "evergreen-ui";
import { useEffect, useContext } from "react";
import useRequest from "../../utils/Request";
import moment from "moment";
import Money from "../../utils/Money";
import { PartnerContext } from "../../utils/UserContext";

export default function AutoDebitRecords() {
  const user = useContext(PartnerContext);
  const [records, setRecords] = useState([]);
  const [date, setDate] = useState(new Date());

  const tableColumns = [
    {
      title: "Date",
      render: (d) => (
        <Typography.Text strong>
          {moment(d?.date).format("ddd Do MMM, YYYY")}{" "}
        </Typography.Text>
      ),
    },
    {
      title: "Total Transactions",
      render: (d) => <p> {d?.totalTransactions?.totalTransactions || 0}</p>,
    },
    // {
    //   title: "Transactions Volume",
    //   render: (d) => (
    //     <Typography.Text strong>
    //       GHS {Money(Math.abs(d?.totalTransactions?.totalAmount) || 0)}
    //     </Typography.Text>
    //   ),
    // },
    {
      title: "Total Amount",
      render: (d) => (
        <Typography.Text strong>GHS {Money(d?.amount)}</Typography.Text>
      ),
    },
    {
      title: "Reference",
      render: (d) => <Typography.Text strong>{d?.reference}</Typography.Text>,
    },
    {
      title: "Description",
      render: (d) => <Typography.Text strong>{d?.description}</Typography.Text>,
    },
    {
      title: "Time Generated",
      render: (d) => (
        <Typography.Text strong>
          {moment(d?.createdAt).format("ddd Do MMM, YYYY hh:mm a")}
        </Typography.Text>
      ),
    },
  ];

  const [getBalanceSheets, { loading: gettingBalanceSheets }] = useRequest(
    { api: 2, path: "/payment/transactions/auto/records" },
    {
      onCompleted: (d) => {
        setRecords(d?.data);
        // setAccounts(d?.data);
      },
      onError: (e) => {
        toaster.danger(e?.response?.data);
      },
    }
  );

  useEffect(() => {
    document.title = `${user?.company?.name || 'Merchant'} - Automatic Card Processing Fees`;
    getBalanceSheets({ date: date.toString() });
  }, [date, user?.company?.name]);

  return (
    <div>
      <div className="md:flex md:items-center md:justify-between">
        <div className="min-w-0 flex-1">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            Automatic Card Processing Fees Debit
          </h2>
          <p>Debbited each day at exactly 12:05 Am for previous day</p>
        </div>
        <div className="mt-4 flex md:ml-4 md:mt-0">
          <DatePicker.MonthPicker
            onChange={(t) => {
              console.log(t.toDate());
              setDate(t.toDate());
            }}
            onSelect={(t) => {
              console.log(t);

              getBalanceSheets({ date: t.toDate().toString() });
              //   console.log(t);
            }}
          />
        </div>
      </div>
      <Table
        style={{ marginTop: 20 }}
        loading={gettingBalanceSheets}
        columns={tableColumns}
        pagination={false}
        dataSource={records}
      />
    </div>
  );
}
